import { useParams } from 'react-router';

import { useGetAdmissionSurveyQuery } from '@/api/endpoints/schools/schoolSelectionPanel';
import type { IApiError } from '@/api/types';
import { FetchErrorSection, Loader } from '@/shared/components';

import { ESelectionPanelTabs } from '../../../_components/SelectionPanelHeader/consts';
import { SelectionPanelHeader } from '../../../_components/SelectionPanelHeader/SelectionPanelHeader';
import { UnavailableSection } from '../../../_components/UnavailableSection/UnavailableSection';

import { ApplicationsPage } from './ApplicationsPage';
import styles from './ApplicationsPage.module.scss';

export const ApplicationsPageWrapper = () => {
  const { id: schoolId } = useParams();

  const {
    data: surveyData,
    isLoading: isSurveyLoading,
    isError: isSurveyFetchError,
    error: surveyError,
  } = useGetAdmissionSurveyQuery({ schoolId: Number(schoolId) });

  if (isSurveyLoading) {
    return <Loader isSpinning />;
  }

  if (isSurveyFetchError) {
    if ((surveyError as IApiError)?.status === 404) {
      return (
        <div className={styles.wrapper}>
          <SelectionPanelHeader currentTab={ESelectionPanelTabs.Applications} />
          <UnavailableSection unavailableText="Данная секция станет доступна после создания опроса" />
        </div>
      );
    }
    return <FetchErrorSection />;
  }

  if (surveyData) {
    return <ApplicationsPage schoolId={Number(schoolId)} />;
  }

  return null;
};
